import dynamic from "next/dynamic";
import { useTranslation } from "next-i18next";
// BOOTSTRAP
import Button from "react-bootstrap/Button";
// COMPONENTS
const CustomModal = dynamic(() => import("@/components/portals/CustomModal/CustomModal"), { ssr: false });
import LoginForm from "@/components/core/LoginForm/LoginFormComponent";
import SignupForm from "@/components/core/SignupForm/SignupFormComponent";
// CONTEXT
import { useModal } from "@/components/context/ModalContext";
// STYLE
import s from "./LoginSignupButtons.module.scss";

export default function LoginSignupButtons({ text }) {
  const { t } = useTranslation("common");
  // Custom modal context state
  const { showModal, hideModal } = useModal();

  const showLoginModal = () =>
    showModal(CustomModal, {
      backdrop: "static",
      children: <LoginForm />,
      closeButton: true,
    });

  const showSignupModal = () =>
    showModal(CustomModal, {
      backdrop: "static",
      children: <SignupForm />,
      closeButton: true,
    });

  return (
    <div className={s.login_signup_wrapper}>
      <div className="d-flex justify-content-center">
        <p>{text}</p>
      </div>
      <div className={s.login_signup_buttons_wrapper}>
        <div className="d-flex px-1">
          <Button
            className={`p-2 mx-1 ${s.button_style}`}
            variant="dark"
            onClick={() => showLoginModal()}
          >
            {t("common:login-modal.login").toUpperCase()}
          </Button>

          <Button
            className={`p-2 mx-1 border-dark ${s.button_style}`}
            variant="light"
            onClick={() => showSignupModal()}
          >
            {t("common:login-modal.signup").toUpperCase()}
          </Button>
        </div>
      </div>
    </div>
  );
}
